<template>
  <el-dialog append-to-body title="自然村列表" :visible="show" :close-on-click-modal="false" @close="closeDialog" width="600px">
    <div class="v-container">
      <div class="v-page-header">自然村列表</div>
      <div class="v-header">
        <el-cascader
          v-if="userLevel != 3"
          v-model="regionData"
          placeholder="地域筛选"
          size="mini"
          :props="{ value: 'id', label: 'name', children: 'child', checkStrictly: true, expandTrigger: 'hover' }"
          :options="regionList"
          filterable
          style="width: 170px; margin-right: 5px"
        />
        <el-input v-model="keyword" class="v-form-item" size="mini" placeholder="作品名称" style="width: 170px"></el-input>
        <el-button class="v-ml-5" type="primary" size="mini" @click="getList(1)">搜索</el-button>
        <el-button size="mini" @click="reset">重置</el-button>
      </div>
      <div class="v-content" v-loading="loading">
        <el-table border size="small" :data="lists" height="300">
          <el-table-column prop="name" label="自然村名称" />
          <el-table-column prop="area_name" label="所属区域" width="200" />
          <el-table-column align="right" label="操作" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button @click="doSelect(scope.row)" size="min" class="v-ml-5">确认选择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="v-footer">
        <el-pagination
          layout="total,sizes,prev, pager, next"
          @size-change="
            (page_size) => {
              getList(page, page_size);
            }
          "
          @current-change="
            (page) => {
              getList(page);
            }
          "
          :current-page.sync="page"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: 'works',
    event: 'change',
  },

  data() {
    return {
      config: this.config,
      page: 1,
      page_size: 10,
      total: 0,
      lists: [],
      live_status: '',
      loading: false,
      keyword: '',
      regionList: [],
      regionData: [],
      userLevel: this.$store.getters.userInfo.level,
    };
  },

  mounted() {
    this.getList();
    this.getAreaList();
  },

  methods: {
    closeDialog() {
      this.$emit('update:show', false);
    },

    async getList(page, page_size) {
      this.loading = true;
      this.page = page ? page : this.page;
      this.page_size = page_size ? page_size : this.page_size;
      try {
        let res = await this.api.works.lists({
          page: this.page,
          page_size: this.page_size,
          keyword: this.keyword,
          area_id: this.regionData.length ? this.regionData[this.regionData.length - 1] : '',
          live_status: 2,
        });
        this.lists = res.data.data;
        this.total = res.data.total;
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    reset() {
      this.regionData = [];
      this.keyword = '';
      this.live_status = '';
      this.getList(1);
    },

    //地域列表
    async getAreaList() {
      try {
        this.regionList = await this.$store.dispatch('user/getAreaList');
      } catch (e) {
        console.error(e);
      }
    },

    doSelect(row) {
      this.$emit('change', { id: row.id, name: row.name });
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.v-header {
  display: flex;
  justify-content: flex-end;
}

.cover-preview {
  display: block;
  height: 60px;
  margin: 0 auto;
}

.category-name {
  color: #3582d1;
}

.link {
  color: #3582d1;
  cursor: pointer;
}

.recommend-box /deep/ .el-loading-spinner {
  margin-top: -10px;
}
</style>
